module.exports = __webpack_public_path__ + "static/img/areaA-31.229a31f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/areaA-31.png
// module id = 975
// module chunks = 1